import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from './reducers'
import thunk from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['companies']
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [thunk];

/**
 * pass this to compase method if you have installed dev tools.
 * window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
*/
const store = createStore(persistedReducer, compose(
  applyMiddleware(...middlewares)));

const persistor = persistStore(store);

export default { store, persistor };